angular.module('env.log.omLogger', [])

    .config(function (omLoggerProvider) {
        if (om.config.logger) {
            omLoggerProvider.config.consoleAppender = _.defaults(om.config.logger.consoleAppender, omLoggerProvider.config.consoleAppender);
            omLoggerProvider.config.ajaxAppender = _.defaults(om.config.logger.ajaxAppender, omLoggerProvider.config.ajaxAppender);
            if (om.config.debug) {
                omLoggerProvider.config.consoleAppender.level = 0;
            }
            omLoggerProvider.config.ajaxAppender.url = om.config.build.baseUrl + "/" + omLoggerProvider.config.ajaxAppender.url;
        }
    })

    .provider('omLogger', function ($injector) {
        let _omLoggerProvider = this;
        let logStorage = [];
        let $http;

        const defaultConfig = { // default config
            consoleAppender: {
                enabled: true,
                level: 3000
            },

            ajaxAppender: {
                enabled: false,
                bufferSize: 10,
                bufferExpirationTime: 10000,
                level: 0,
                sendLevel: 6000,
                url: om.config.build.baseUrl + "/log"
            }
        };

        _omLoggerProvider.config = defaultConfig;

        //region Utils

        _omLoggerProvider.assert = function () {
            console.assert.apply(console, arguments);
        };

        _omLoggerProvider.count = function () {
            console.count.apply(console, arguments);
        };

        _omLoggerProvider.dir = function () {
            console.dir.apply(console, arguments);
        };

        _omLoggerProvider.group = function () {
            console.group.apply(console, arguments);
        };

        _omLoggerProvider.groupCollapsed = function () {
            console.groupCollapsed.apply(console, arguments);
        };

        _omLoggerProvider.groupEnd = function () {
            console.groupEnd.apply(console, arguments);
        };

        _omLoggerProvider.time = function () {
            console.time.apply(console, arguments);
        };

        _omLoggerProvider.timeEnd = function () {
            console.timeEnd.apply(console, arguments);
        };

        //endregion

        //region Log messages

        /**
         * Log message with trace level: 1000
         */
        _omLoggerProvider.trace = function () {
            logMessage(1000, arguments);
        };

        /**
         * Log message with debug level: 2000
         */
        _omLoggerProvider.debug = function () {
            logMessage(2000, arguments);
        };

        /**
         * Log message with default(log) level: 3000
         */
        _omLoggerProvider.log = function () {
            logMessage(3000, arguments);
        };

        /**
         * Log message with info level: 4000
         */
        _omLoggerProvider.info = function () {
            logMessage(4000, arguments);
        };

        /**
         * Log message with warning level: 5000
         */
        _omLoggerProvider.warn = function () {
            logMessage(5000, arguments);
        };

        /**
         * Log message with error level: 6000
         */
        _omLoggerProvider.error = function () {
            logMessage(6000, arguments);
        };

        /**
         * Log message with fatal error level: 7000
         */
        _omLoggerProvider.fatal = function () {
            logMessage(7000, arguments);
        };

        //endregion

        //region Helpers

        function logMessage(level, args) {
            if (!_omLoggerProvider.config.consoleAppender.enabled && !_omLoggerProvider.config.ajaxAppender.enabled) {
                return;
            }
            let parsedArgs = parseArguments(args);
            logToConsole(level, parsedArgs);
            logToServer(level, parsedArgs);
        }

        function logToServer(level, args) {
            if (!_omLoggerProvider.config.ajaxAppender.enabled) {
                return;
            }

            if (level >= _omLoggerProvider.config.ajaxAppender.level) {
                let msg = args.messages.length > 1 ? _.str.sprintf.apply(console, args.messages) : args.messages[0];
                _.forEach(args.exceptions, function (ex) {
                    if (ex.header) {
                        msg += "\n" + ex.header;
                    }
                    if (ex.stack) {
                        msg += "\n" + ex.stack;
                    }
                });
                let now = new Date();
                logStorage.push({
                    date: now,
                    timeZoneOffset: now.getTimezoneOffset(),
                    level: level,
                    message: msg
                });
                if (logStorage.length > _omLoggerProvider.config.ajaxAppender.bufferSize) {
                    logStorage.shift();
                }
            }

            if (level >= _omLoggerProvider.config.ajaxAppender.sendLevel) {
                sendLogToServer();
            }
        }

        function sendLogToServer() {
            let now = new Date();
            let toSend = _.clone(logStorage)
                .filter(entry => now.getTime() - entry.date.getTime() < _omLoggerProvider.config.ajaxAppender.bufferExpirationTime);
            logStorage = [];

            try {
                if (!$http) {
                    $http = $injector.get("$http", "omLogger");
                }
                try {
                    $http.post(_omLoggerProvider.config.ajaxAppender.url, JSON.stringify({logs: toSend})).then(
                        function (resp) {
                            // yay!
                        }, function (resp) {
                            handleError(resp)
                        });
                } catch (ex) {
                    handleError(ex)
                }
            } catch (e) {
                try {
                    $.post(_omLoggerProvider.config.ajaxAppender.url, JSON.stringify({logs: toSend}), null, "json");
                } catch (ex) {
                    handleError(ex)
                }
            }

            function handleError(e) {
                console.group("We were unable to send logs to the server");
                console.dir(e);
                console.groupEnd();
            }
        }

        function logToConsole(level, args) {
            if (!_omLoggerProvider.config.consoleAppender.enabled) {
                return;
            }
            if (level < _omLoggerProvider.config.consoleAppender.level) {
                return;
            }

            let msg = args.messages.length > 1 ? _.str.sprintf.apply(null, args.messages) : args.messages[0];
            if (msg) {
                logToConsoleByLevel(level, msg);
            }

            _.forEach(args.exceptions, function (ex) {
                if (ex.stack) {
                    console.group(ex.header);
                    console.log(ex.stack);
                    console.groupEnd();
                } else {
                    logToConsoleByLevel(level, ex.header);
                }
            });
        }

        function logToConsoleByLevel(level, msg) {
            if (level <= 1000) { // trace
                console.log(msg);
            } else if (level <= 2000) { // debug
                console.log(msg);
            } else if (level <= 3000) { // log
                console.log(msg);
            } else if (level <= 4000) { // info
                console.info(msg);
            } else if (level <= 5000) { // warn
                console.warn(msg);
            } else if (level <= 6000) { // error
                console.warn(msg);
            } else { // fatal
                console.warn(msg);
            }
        }


        function parseArguments(args) {
            let messages = [];
            let exceptions = [];

            function parseException(e) {
                let result = {};
                let name = e.name;
                name = !name ? 'Error' : String(name);
                let msg = e.message || e.description;
                msg = !msg ? '' : String(msg);
                result.header = name + (msg ? (': ' + msg) : '');
                if (e.stack) {
                    result.stack = e.stack.toString();
                }
                return result;
            }

            for (let i = 0; i < args.length; i++) {
                let arg = args[i];
                if (arg) {
                    if (arg.stack || arg.message || arg.name) { // if error
                        exceptions.push(parseException(arg));
                    } else {
                        messages.push(arg);
                    }
                }
            }

            return {
                messages: messages,
                exceptions: exceptions
            };
        }

        _omLoggerProvider.getLogs = function () {
            return _.clone(logStorage.slice(0));
        };

        //endregion

        this.$get = function () {
            return {
                assert: _omLoggerProvider.assert,
                count: _omLoggerProvider.count,
                dir: _omLoggerProvider.dir,
                group: _omLoggerProvider.group,
                groupCollapsed: _omLoggerProvider.groupCollapsed,
                groupEnd: _omLoggerProvider.groupEnd,
                time: _omLoggerProvider.time,
                timeEnd: _omLoggerProvider.timeEnd,
                debug: _omLoggerProvider.debug,
                trace: _omLoggerProvider.trace,
                log: _omLoggerProvider.log,
                info: _omLoggerProvider.info,
                warn: _omLoggerProvider.warn,
                error: _omLoggerProvider.error,
                fatal: _omLoggerProvider.fatal,
                getLogs: _omLoggerProvider.getLogs
            };
        };
    })

;
